export enum AccountFitSetupStatus {
  SUCCESS = 'true',
  ERROR = 'error',
  NOT_COMPLETE = 'false'
}

export const isAccountFitEnabled = (org: any) => {
  return org?.properties?.accountFitEnabled !== false
}

export const fetchAccountFitSetupStatus = (org: any) => {
  const acctFitSetup = org?.properties?.accountFitSetup
  if (acctFitSetup === true) {
    return AccountFitSetupStatus.SUCCESS
  } else if (acctFitSetup === false || acctFitSetup === undefined || acctFitSetup === null) {
    return AccountFitSetupStatus.NOT_COMPLETE
  }
  return (acctFitSetup as AccountFitSetupStatus) ?? AccountFitSetupStatus.ERROR
}

export const isAIEngagementSummaryEnabled = (org: any) => {
  return org?.properties?.AIEngagementSummaryEnabled !== false
}

export const accountFitScoringCompletedAtLeastOnce = (org: any) => {
  return org?.properties?.accountFitScoringCompletedAtLeastOnce === true
}
